module.exports = __webpack_public_path__ + "static/img/kv_airplus3.52b87fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/airplus3/kv_airplus3.png
// module id = amur
// module chunks = 1